var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',{staticClass:"container",attrs:{"size":"small"}},[_c('Subtitle',[_vm._v("Ticket Request")]),_c('Description',[_vm._v("Details for ...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }